import React from "react";
import { ChromeDialog } from "@components/chrome-dialog";
import { CopyBestTimesModalRenderer } from "@clockwise/web-commons/src/ui/copy-best-times-modal/copy-best-times-modal.renderer";
import { setShareBestTimesLink } from "@actions/chrome-extension.actions";
import { SidebarLink } from "@clockwise/web-commons/src/ui/scheduling-links-sidebar";
import { useDispatch } from "react-redux";
import copyToClipboard from "@src/util/copyToClipboard";

interface IProps {
  link: SidebarLink | null;
}

const ShareBestTimesLinkModal = ({ link }: IProps) => {
  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => dispatch(setShareBestTimesLink(null)), [dispatch]);

  const handleCopy = React.useCallback((text: string) => copyToClipboard(text), []);

  if (!link) {
    return null;
  }

  return (
    <ChromeDialog open>
      {link && <CopyBestTimesModalRenderer onClose={handleClose} link={link} onCopy={handleCopy} />}
    </ChromeDialog>
  );
};

export default ShareBestTimesLinkModal;
